import { LocaleType } from '@strava/constants';
import { Language } from '@strava/mre';

import { STRAVA_LOCALE_TO_MRE_SUPPORTED_LANGUAGE } from '../constants';

// This function maps Strava locale types to MRE supported languages.
export function mapLocaleToMRESupportedLanguage(locale: LocaleType): Language {
  if (locale in STRAVA_LOCALE_TO_MRE_SUPPORTED_LANGUAGE) {
    return STRAVA_LOCALE_TO_MRE_SUPPORTED_LANGUAGE[
      locale as keyof typeof STRAVA_LOCALE_TO_MRE_SUPPORTED_LANGUAGE
    ];
  }
  return Language.EN;
}
